import Vue from 'vue'
import { formatTextNumber } from 'ice.fo.utils/NumberUtils'

Vue.filter('currency', (value) => {
  if (!value) {
    return '0'
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

Vue.filter('textNumber', formatTextNumber)
